import { Field } from './Field';
import { textAreaClasses } from './fieldStyles';

/**
 * Multi-line text inside the standard field frame.
 *
 * `maxLength` matches the cap in the shared schema, so the control stops at the
 * limit rather than letting someone write 1,400 characters and then telling
 * them to cut it. The cap is also stated in the visible hint — a silent
 * truncation with no explanation is its own kind of broken.
 */
export interface TextAreaFieldProps {
  id: string;
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  hint?: string;
  error?: string;
  required?: boolean;
  maxLength?: number;
  rows?: number;
}

export function TextAreaField({
  id,
  name,
  label,
  value,
  onChange,
  hint,
  error,
  required = false,
  maxLength,
  rows = 4,
}: TextAreaFieldProps) {
  return (
    <Field id={id} label={label} hint={hint} error={error} optional={!required}>
      {({ id: controlId, describedBy, invalid }) => (
        <textarea
          id={controlId}
          name={name}
          rows={rows}
          maxLength={maxLength}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          aria-required={required || undefined}
          aria-invalid={invalid || undefined}
          aria-describedby={describedBy}
          className={textAreaClasses(invalid)}
        />
      )}
    </Field>
  );
}
